__turbopack_context__.v({
  "empty": "WShopNewProducts-module__hoeStW__empty",
  "header": "WShopNewProducts-module__hoeStW__header",
  "heading": "WShopNewProducts-module__hoeStW__heading",
  "productList": "WShopNewProducts-module__hoeStW__productList",
  "root": "WShopNewProducts-module__hoeStW__root",
  "showAllBtn": "WShopNewProducts-module__hoeStW__showAllBtn",
});
